import Immutable from "immutable";
import React from "react";
import { AdditionalSearch } from "../search/components/AdditionalSearch";
import { createDefaultSearchDefinition } from "../search/createDefaultSearchDefinition";
import { createSearchStore } from "../search/createSearchStore";
import { FavoriteDropdown } from "../search/favorites/FavoriteDropdown";
import { PrintResultsButton } from "../search/header/PrintResultsButton";
import { renderSearch } from "../search/renderSearch";
import { resultWithFavoritesRenderConfig } from "../search/result/table/generateResultCells";
import { columns } from "./columns";
import { searchComponents, tabComponent } from "./searchComponents";
import { WinnersAndLosersTitle } from "./WinnersAndLosersTitle";
import { WINNERS_AND_LOSERS_NAMESPACE } from "../search/constants";
import { searchPageProps } from "../common/types/search/search";
import { searchDefinition } from "../search/SearchContainer";

export const defaultWinnersAndLosersInput = (selectedYear?: string) => {
	const currentYear = new Date().getFullYear().toString();
	return Immutable.Map({
		airline_search_by: "winners",
		year: selectedYear || currentYear,
	});
};

export default function WinnersAndLosersSearch({ roles }: searchPageProps) {
	const store = createSearchStore(roles, defaultWinnersAndLosersInput());

	let searchDefinition: searchDefinition = createDefaultSearchDefinition({
		columns,
		resultRenderConfig: resultWithFavoritesRenderConfig,
		shouldFetchQuickSearchCriteria: false,
	});

	searchDefinition = {
		...searchDefinition,
		adCode: "hero_banner_operators",
		additionalSearch: (
			<AdditionalSearch
				criteria={searchComponents}
				additionalActions={
					<>
						<FavoriteDropdown />
						<PrintResultsButton />
					</>
				}
				namespace={WINNERS_AND_LOSERS_NAMESPACE}
			/>
		),
		customizeQuickSearch: {
			enabled: false,
			radios: undefined,
		},
		namespace: WINNERS_AND_LOSERS_NAMESPACE,
		searchTitle: <WinnersAndLosersTitle />,
		searches: {
			searchAlertEnabled: false,
			searchesEnabled: false,
			viewBindingEnabled: true,
		},
		tabSearch: tabComponent,
		views: {
			viewsEnabled: false,
			visibilitySelector: undefined,
		},
	};

	return renderSearch(store, searchDefinition);
}
